import { useState } from "react";
import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

const getTitleUUID = createUUID();
const createTitleUUID = createUUID();
const deleteTitleUUID = createUUID();

export function useManageTitleViewModel() {
  const [titles, setTitles] = useState([]);

  const stateManager = useComponentState();

  const getTitles = () => {
    stateManager.abort(getTitleUUID);
    stateManager.run(async () => {
      const response = await subscriptionService.titles.getAll({
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setTitles(response.data);
      }
    }, getTitleUUID);
  };

  const createTitle = (data, callback = null) => {
    stateManager.abort(createTitleUUID);
    stateManager.run(async () => {
      const response = await subscriptionService.titles.create({
        data,
        toastMessageConfig: {
          success: { text: "Title was created successfully." },
          failure: { text: "Failed to create title." },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        callback();
      }
    }, createTitleUUID);
  };

  const deleteTitle = (id, data, callback) => {
    stateManager.abort(deleteTitleUUID);
    stateManager.run(async () => {
      const response = await subscriptionService.titles.delete({
        id,
        data,
        toastMessageConfig: {
          success: { text: "Title deleted successfully!" },
          failure: { text: "Failed to delete title!" },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        callback();
      }
    }, deleteTitleUUID);
  };

  return {
    titles,
    getTitles,
    deleteTitle,
    createTitle,
    stateManager,
  };
}
